export enum KoneEnum {
  Peruutettu = 0,
  LisaaminenOnnistui,
  LisaaminenEpaonnistui,
  PoistaminenOnnistui,
  PoistaminenEpaonnistui,
  MuokkaaminenOnnistui,
  MuokkaaminenEpaonnistui,
}
